import { TCreateOnsiteInterviewPageLocationState } from '../Types';
import { createUseSafeLocationState } from '~/utils/SafeLocationState';

export const useSafeLocationState =
  createUseSafeLocationState<TCreateOnsiteInterviewPageLocationState>({
    isAfterJobPosting: false,
  });
